module.exports = {
	"id": "BD",
	"name": "Bangladesh",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.004044,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.006066,
			"11": 0.012132,
			"12": 0.01011,
			"13": null,
			"14": 0.004044,
			"15": null,
			"16": 0.002022,
			"17": 0.004044,
			"18": 0.006066,
			"19": 0.008088,
			"20": 0.006066,
			"21": 0.008088,
			"22": 0.006066,
			"23": 0.004044,
			"24": 0.004044,
			"25": 0.008088,
			"26": 0.008088,
			"27": 0.008088,
			"28": 0.024264,
			"29": 0.014154,
			"30": 0.008088,
			"31": 0.084924,
			"32": 0.008088,
			"33": 0.04044,
			"34": 0.006066,
			"35": 0.004044,
			"36": 0.004044,
			"37": 0.002022,
			"38": 0.006066,
			"39": 0.02022,
			"40": 0.006066,
			"41": 0.006066,
			"42": 0.006066,
			"43": 0.208266,
			"44": 0.01011,
			"45": 0.016176,
			"46": 0.01011,
			"47": 0.03033,
			"48": 0.048528,
			"49": 0.301278,
			"50": 0.044484,
			"51": 0.264882,
			"52": 0.105144,
			"53": 5.184408,
			"54": 1.924944,
			"55": 0.123342,
			"56": 0.048528,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.179958,
			"4": 0.012132,
			"5": 0.006066,
			"6": 0.004044,
			"7": 0.004044,
			"8": 0.008088,
			"9": 0.008088,
			"10": 0.01011,
			"11": 0.034374,
			"12": 0.024264,
			"13": 0.014154,
			"14": 0.02022,
			"15": 0.02022,
			"16": 0.012132,
			"17": 0.01011,
			"18": 0.014154,
			"19": 0.016176,
			"20": 0.016176,
			"21": 0.014154,
			"22": 0.012132,
			"23": 0.008088,
			"24": 0.012132,
			"25": 0.014154,
			"26": 0.008088,
			"27": 0.012132,
			"28": 0.008088,
			"29": 0.052572,
			"30": 0.034374,
			"31": 0.018198,
			"32": 0.024264,
			"33": 0.034374,
			"34": 0.02022,
			"35": 0.036396,
			"36": 0.044484,
			"37": 0.03033,
			"38": 0.06066,
			"39": 0.048528,
			"40": 0.058638,
			"41": 0.052572,
			"42": 0.046506,
			"43": 0.226464,
			"44": 0.24264,
			"45": 0.09099,
			"46": 0.099078,
			"47": 0.513588,
			"48": 0.430686,
			"49": 3.754854,
			"50": 1.073682,
			"51": 0.016176,
			"52": 0.002022,
			"3.5": 0.008088,
			"3.6": 0.02022
		},
		"opera": {
			"9": null,
			"11": 0.004044,
			"12": 0.002022,
			"15": null,
			"16": null,
			"17": 0.002022,
			"18": 0.002022,
			"19": 0.002022,
			"20": 0.002022,
			"21": 0.002022,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.004044,
			"29": 0.008088,
			"30": 0.012132,
			"31": null,
			"32": 0.004044,
			"33": 0.01011,
			"34": 0.018198,
			"35": 0.012132,
			"36": 0.02022,
			"37": 0.179958,
			"38": 0.022242,
			"39": 0.012132,
			"40": 0.422598,
			"41": 0.088968,
			"42": null,
			"43": null,
			"9.5-9.6": 0.006066,
			"10.0-10.1": 0.004044,
			"10.5": null,
			"10.6": 0.016176,
			"11.1": 0.008088,
			"11.5": 0.004044,
			"11.6": 0.008088,
			"12.1": 0.014154
		},
		"safari": {
			"0": null,
			"4": 0.004044,
			"5": null,
			"6": 0.006066,
			"7": 0.004044,
			"8": 0.008088,
			"9": 0.01011,
			"10": 0.04044,
			"3.1": null,
			"3.2": null,
			"5.1": 0.006066,
			"6.1": null,
			"7.1": null,
			"9.1": 0.024264
		},
		"ios_saf": {
			"8": 0,
			"10": 0.752615690258,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0202821219817,
			"8.1-8.4": 0.0374703609492,
			"9.0-9.2": 0.0178757685262,
			"9.3": 0.272720058285
		},
		"android": {
			"3": 0,
			"4": 0.0955298501292,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0119412312661,
			"4.1": 0.344589816537,
			"4.2-4.3": 0.861474541344,
			"4.4": 1.97542082946,
			"4.4.3-4.4.4": 1.99247973127
		},
		"ie": {
			"6": 0.00669730316742,
			"7": null,
			"8": 0.189756923077,
			"9": 0.0245567782805,
			"10": 0.0379513846154,
			"11": 0.229940742081,
			"5.5": null
		},
		"op_mob": {
			"0": 1.96580737367,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0546057603798
		},
		"edge": {
			"12": 0.06066,
			"13": 0.056616,
			"14": 0.07077
		},
		"ie_mob": {
			"10": 0.158885802817,
			"11": 0.646892197183
		},
		"bb": {
			"7": 0.0059835,
			"10": null
		},
		"samsung": {
			"0": 1.292436
		},
		"and_uc": {
			"0": 15.71666
		},
		"op_mini": {
			"0": 26.4849808659
		},
		"and_chr": {
			"0": 27.500998
		},
		"and_ff": {
			"0": 0.03989
		}
	},
	"total": 98.1357306312
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BD.json
 ** module id = 473
 ** module chunks = 0
 **/